import "../../chunk-5WRI5ZAA.js";

// src/livePreview/editButton/editButton.constant.ts
var EDIT_BUTTON_TOOLTIP_ID = "cslp-tooltip";
export {
  EDIT_BUTTON_TOOLTIP_ID
};
//# sourceMappingURL=editButton.constant.js.map